import { render, staticRenderFns } from "./ProvisionedOrdersLaundry.vue?vue&type=template&id=7a6c3cf6"
import script from "./ProvisionedOrdersLaundry.vue?vue&type=script&lang=js"
export * from "./ProvisionedOrdersLaundry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports